import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { snakelizeKeys } from 'utils/format'
import { resetErrorMessage } from 'actions/common'
import { signupStart, signupSubmit } from 'actions/signup'
import { getRecaptchaSiteKey, getMarkets } from 'selectors/settings'
import { getFieldMessages } from 'selectors/error'
import { isFormSubmitted } from 'selectors/signup'
import Form from './form'

class FormContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      started: false,
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onVerifyCallback = this.onVerifyCallback.bind(this)
  }

  onChange(name, value) {
    this.onUpdate()

    this.setState({
      started: true,
      [name]: value,
    })
  }

  onSubmit(e) {
    e.preventDefault()

    const data = snakelizeKeys({ ...this.state })
    this.props.signupSubmit(data)
  }

  onVerifyCallback(response) {
    this.onUpdate()

    this.setState({ gRecaptchaResponse: response })
  }

  onUpdate() {
    if (!this.state.started) {
      this.props.signupStart()
    }

    if (this.props.errors) {
      this.props.resetErrorMessage()
    }
  }

  render() {
    return (
      <Form
        errors={this.props.errors}
        isSubmitted={this.props.isSubmitted}
        markets={this.props.markets}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        onVerifyCallback={this.onVerifyCallback}
        recaptchaSiteKey={this.props.recaptchaSiteKey}
        staticUrl={this.props.staticUrl}
      />
    )
  }

}

FormContainer.propTypes = {
  errors: PropTypes.object,
  markets: PropTypes.array,
  isSubmitted: PropTypes.bool,
  recaptchaSiteKey: PropTypes.string,
  resetErrorMessage: PropTypes.func,
  signupStart: PropTypes.func,
  signupSubmit: PropTypes.func,
  staticUrl: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => ({
  errors: getFieldMessages(state),
  isSubmitted: isFormSubmitted(state),
  markets: getMarkets(state),
  recaptchaSiteKey: getRecaptchaSiteKey(state),
  ...ownProps,
})

const mapDispatchToProps = {
  signupStart,
  signupSubmit,
  resetErrorMessage,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/form/form-container.js
 **/